import cn from 'classnames';

export default function DefaultCheckbox({
  isDisabled,
  isChecked,
  onClick,
  text,
  register
}) {
  return (
    <div className="default-checkbox-wrapper">
      <label className="default-checkbox">
        <input
          type="checkbox"
          disabled={isDisabled}
          checked={isChecked}
          {...register}></input>
        <span
          className={cn('default-custom-checkbox', { disabled: isDisabled })}
          onClick={onClick}></span>
        {text}
      </label>
    </div>
  );
}
